import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import styles from "../agent-response.module.scss";

type JDDetailsAgentProps = {
    parsedContent: any;
};

export default function JDDetailsAgent({
    parsedContent,
}: JDDetailsAgentProps): JSX.Element {
    const answer = safeJSONParse(parsedContent?.answer);
    const question = parsedContent?.question;
    const jdDetails = answer;

    // Capitalize first letter of each word
    const capitalizeWords = (str: string) => {
        if (!str) return str;
        return str
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <div className={styles.pressReleaseContent}>
            {/* Job Title and Location */}
            {jdDetails?.job_title && (
                <div style={{ marginBottom: "12px" }}>
                    <h2 style={{ marginBottom: "7px" }}>
                        Job description for{" "}
                        {jdDetails.job_title ? ` ${jdDetails.job_title}` : ""}
                    </h2>
                    <h4 style={{ marginBottom: "0" }}>Job Title: {capitalizeWords(jdDetails.job_title)}</h4>
                    {jdDetails?.location && (
                        <p style={{ marginBottom: "0" }}>Location: {jdDetails.location}</p>
                    )}
                </div>
            )}

            {/* About Organization */}
            {jdDetails?.about_organization && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0" }}>About the Organization:</h4>
                    <p style={{ marginBottom: "0" }}>{jdDetails.about_organization}</p>
                </div>
            )}

            {/* Overview */}
            {jdDetails?.overview && jdDetails.overview.length > 0 && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0" }}>Overview:</h4>
                    <ul style={{ marginBottom: "0" }}>
                        {jdDetails.overview.map((item: string, idx: number) => (
                            <li key={idx}>{item}</li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Responsibilities */}
            {jdDetails?.responsibilities && jdDetails.responsibilities.length > 0 && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0" }}>Responsibilities:</h4>
                    <ul style={{ marginBottom: "0" }}>
                        {jdDetails.responsibilities.map((responsibility: string, idx: number) => (
                            <li key={idx}>{responsibility}</li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Qualifications */}
            {jdDetails?.qualifications && jdDetails.qualifications.length > 0 && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0" }}>Requirements:</h4>
                    <ul style={{ marginBottom: "0" }}>
                        {jdDetails.qualifications.map((qualification: string, idx: number) => (
                            <li key={idx}>{qualification}</li>
                        ))}
                    </ul>
                </div>
            )}

            {/* What We Look For */}
            {jdDetails?.what_we_look_for && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0" }}>What We Look For:</h4>
                    <p style={{ marginBottom: "0" }}>{jdDetails.what_we_look_for}</p>
                </div>
            )}

            {/* Why G42 */}
            {jdDetails?.why_g42 && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0" }}>What working at G42 offers:</h4>
                    {Array.isArray(jdDetails.why_g42) ? (
                        <ul style={{ marginBottom: "0" }}>
                            {jdDetails.why_g42.map((item: any, idx: number) => (
                                <li key={idx}>
                                    {item.type}: {item.value}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p style={{ marginBottom: "0" }}>{jdDetails.why_g42}</p>
                    )}
                </div>
            )}

            {/* Application */}
            {jdDetails?.application && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0" }}>Application:</h4>
                    <p style={{ marginBottom: "0" }}>{jdDetails.application}</p>
                </div>
            )}

            {/* Final Question */}
            <div className={styles.finalQuestion}>{question}</div>
        </div>
    );
}
